"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var AnalyticsContentType_1 = require("../types/enums/AnalyticsContentType");
var BrandType_1 = require("../types/enums/BrandType");
var utils_1 = require("./utils");
var Title_1 = require("./Title");
var Slot_1 = require("./Slot");
exports.getContentTypeBySlot = function (slot) {
    if (Slot_1.isShow(slot)) {
        return Slot_1.isSport(slot) ? AnalyticsContentType_1.AnalyticsContentType.SPORT : AnalyticsContentType_1.AnalyticsContentType.SHOW;
    }
    if (Slot_1.isMovie(slot)) {
        return AnalyticsContentType_1.AnalyticsContentType.MOVIE;
    }
    return undefined;
};
exports.getContentTypeByBrand = function (brand) {
    if (utils_1.isNilOrEmpty(brand)) {
        return undefined;
    }
    if (Title_1.isShow(brand)) {
        return Title_1.isSport(brand) ? AnalyticsContentType_1.AnalyticsContentType.SPORT : AnalyticsContentType_1.AnalyticsContentType.SHOW;
    }
    return AnalyticsContentType_1.AnalyticsContentType.MOVIE;
};
exports.getVodSeasonNumber = function (season) { return season === null || season === void 0 ? void 0 : season.number; };
exports.getVodEpisodeNumber = function (episode) {
    return (episode === null || episode === void 0 ? void 0 : episode.number) || undefined;
};
exports.getSlotSeasonNumber = function (slot) {
    var _a, _b;
    return ((_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.__typename) === BrandType_1.BrandType.Episode
        ? exports.getVodSeasonNumber((_b = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _b === void 0 ? void 0 : _b.season)
        : undefined;
};
exports.getSlotEpisodeNumber = function (slot) {
    var _a;
    return ((_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.__typename) === BrandType_1.BrandType.Episode
        ? exports.getVodEpisodeNumber(slot === null || slot === void 0 ? void 0 : slot.programme)
        : undefined;
};
// Specific for Youbora
exports.getYouboraSlotTitle = function (slot) { var _a, _b, _c, _d; 
// Movie title for movies; TV show (brand) title for TV shows and Sport
return ((_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.__typename) === 'Episode' ? (_c = (_b = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _b === void 0 ? void 0 : _b.show) === null || _c === void 0 ? void 0 : _c.title : (_d = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _d === void 0 ? void 0 : _d.title; };
exports.getYouboraSlotProgram = function (slot) {
    // Movie title for movies, TV Show (brand) title + season no. + episode no. for TV shows, Episode title for Sport
    return Slot_1.getSlotTitle(slot);
};
exports.getYouboraSlotChannel = function (channel) { return channel === null || channel === void 0 ? void 0 : channel.title; };
var getBrandGenres = function (brand) {
    var genres = ramda_1.concat((brand === null || brand === void 0 ? void 0 : brand.primaryGenres) || [], (brand === null || brand === void 0 ? void 0 : brand.allGenres) || []);
    var genreTitles = genres.map(function (genre) { return genre.title; });
    return utils_1.isNotNilOrEmpty(genreTitles) ? ramda_1.uniq(genreTitles) : undefined;
};
exports.getYouboraSlotGenres = function (slot) {
    var _a;
    var brand = Slot_1.isShow(slot) ? (slot === null || slot === void 0 ? void 0 : slot.programme).show : slot === null || slot === void 0 ? void 0 : slot.programme;
    return (_a = getBrandGenres(brand)) === null || _a === void 0 ? void 0 : _a.join(',');
};
// Movie title for movies; TV show (brand) title for TV shows and Sport
exports.getYouboraVodTitle = function (brand) { return brand === null || brand === void 0 ? void 0 : brand.title; };
exports.getYouboraVodProgram = function (brand, episode) {
    // Movie title for movies, TV Show (brand) title + season no. + episode no. for TV shows, Episode title for Sport
    return Title_1.getVodTitle(brand, episode);
};
var getControllingChannel = function (brand) {
    var brands = brand === null || brand === void 0 ? void 0 : brand.brands;
    if (ramda_1.isNil(brands) || ramda_1.isEmpty(brands === null || brands === void 0 ? void 0 : brands.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.title) !== 'untitled'; }))) {
        return undefined;
    }
    return brands === null || brands === void 0 ? void 0 : brands.map(function (i) { return i === null || i === void 0 ? void 0 : i.title; });
};
exports.getYouboraControllingChannel = function (brand) { var _a; return (_a = getControllingChannel(brand)) === null || _a === void 0 ? void 0 : _a.join(','); };
exports.getYouboraBrandGenres = function (brand) { var _a; return (_a = getBrandGenres(brand)) === null || _a === void 0 ? void 0 : _a.join(','); };
// Specific for Segment
exports.getSegmentSlotTitle = function (slot) {
    // Episode title for Sport only, TV show (brand) title for TV Show, movie title for Movie
    return Slot_1.getSlotTitle(slot, false, true);
};
exports.getSegmentSlotTitleWithBrand = function (slot, isSportShow, brandTitle) {
    // Episode title for Sport only, TV show (brand) title for TV Show, movie title for Movie
    return Slot_1.getSlotTitleWithBrand(slot, isSportShow, brandTitle, false, true);
};
/**
 * This function is trying to align the data type with VOD's controlling channel, should be only used for
 * VideoContentStart, VideoContentStop, recordUpgradeEncountered.
 * @param channel
 * @returns array with channel title
 */
exports.getSegmentSlotChannel = function (channel) {
    return (channel === null || channel === void 0 ? void 0 : channel.title) ? [channel === null || channel === void 0 ? void 0 : channel.title] : undefined;
};
exports.getSegmentSlotGenres = function (slot) {
    var brand = Slot_1.isShow(slot) ? (slot === null || slot === void 0 ? void 0 : slot.programme).show : slot === null || slot === void 0 ? void 0 : slot.programme;
    return getBrandGenres(brand);
};
exports.getSegmentVodTitle = function (brand, episode) {
    // Episode title for Sport only, TV show (brand) title for TV Show, movie title for Movie
    return Title_1.getVodTitle(brand, episode, true);
};
exports.getSegmentControllingChannel = function (brand) {
    return getControllingChannel(brand);
};
exports.getSegmentBrandGenres = function (brand) { return getBrandGenres(brand); };
//# sourceMappingURL=Analytics.js.map